import Helmet from 'react-helmet';
import React from 'react';
import { connect } from 'react-redux';
import { createPureComponent, PathUtils, TitleUtils } from 'module/Common';
import { GoHomeLink, Title } from './NotFound.s';
import { Localized } from 'module/Model/Localized';
import { LocalizedText, NavProvider } from 'module/View/Common';
import { RouterSelector } from 'module/Redux/Router';
import { RouteType } from 'module/Model/Routes';
import { State } from 'module/Redux';

type StateProps = {
  lang: PathUtils.Lang;
};

const mapStateToProps = (s: State): StateProps => ({
  lang: RouterSelector.selectLang(s),
});

type Props = StateProps;

const NotFoundComp = createPureComponent<Props>('NotFoundComp', ({ lang }) => {
  return (
    <>
      <Helmet>
        <title>{TitleUtils.create('404')}</title>
      </Helmet>
      <div>
        <Title>
          <LocalizedText content={Localized.create('404 - Impossible de trouver la page', `404 - Not found`)} />
        </Title>
        <NavProvider routeType={RouteType.Home} requestNavigation={true}>
          {params => (
            <GoHomeLink {...params.getAnchorProps()}>
              <LocalizedText content={Localized.create(`Retourner à l'accueil`, 'Go back to Home page')} />
            </GoHomeLink>
          )}
        </NavProvider>
      </div>
    </>
  );
});

export const NotFound = connect(mapStateToProps)(NotFoundComp);



// WEBPACK FOOTER //
// ./src/module/View/Main/NotFound/NotFound.tsx